export const ROOT = '/'
export const APP_PREFIX_PATH = ''
export const API_PREFIX_PATH = process.env.REACT_APP_API
export const AUTH_PREFIX_PATH = '/auth'
export const UI_COMPONENTS_PREFIX_PATH = '/ui-components'
export const PAGES_PREFIX_PATH = '/pages'
export const DOCS_PREFIX_PATH = '/docs'
